import React, { useEffect, useState } from "react";
import {
    DialogActions,
    DialogTitle,
    DialogContent,
    Button,
    CircularProgress,
    FormControlLabel, 
    Switch
} from "@material-ui/core";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import AuthService from "tools/AuthService";
import { Field } from 'redux-form';
import {
    phoneNumberValidation,
    validateEmail,
    maxLength20,
    required
} from 'tools/forms/validators'
import { InputField, DropdownField, CheckboxField } from "components/forms/reduxForm";
import { statesOptions, businessTypeOption } from "constants/constantVariables";
import { Dialog } from "components/shared/Dialog";
import { PasswordValidator } from "components/PasswordValidation/PasswordValidator";
import strings from "strings";
import { startGmailOauth } from "actions/user";

const passwordValidation = (values, allValues) => {
    const newPassword = allValues["user"]["password"];
    if (newPassword === values) {
        return undefined;
    } else {
        return "Passwords dont match";
    }
};

const ClientForm = (props) => {
    const {
        open,
        onClose,
        onSubmit,
        mode = "Create",
        loading,
        submitting,
        pristine,
        creditMemoApprovalEnabled
    } = props;
    const [openTooltip, setOpenTooltip] = useState(false)
    const [valid, setValid] = useState(false)
    const [isSwitchChecked, setIsSwitchChecked] = useState(false);
    const gs = useSelector(state => state)
    const { password } = gs.form?.clientForm?.values?.user || {};
    const userRoles = gs.root.rolesList.map(data => ({ label: data.name, value: data.roleId }))
    const isPlatformAdmin = AuthService.hasRole(strings.ROX_ADMIN)
    let title = `${mode} ${strings.CLIENT}`, clientPrefix = "";

    useEffect(() => {
        if (mode !== 'Create')
            setValid(true)
    }, [mode]);

    const onGmailConnect = () => {
        startGmailOauth(gs?.client?.clientById?.clientId)
        .then((res) => {
            const redirectUrl = res?.response?.redirectUrl;
            window.location = redirectUrl
        })
    };

    if (isPlatformAdmin) {
        title = `${mode === strings.EDIT ? strings.EDIT : ''} ${strings.CUSTOMER} ${strings.DETAILS}`
        clientPrefix = "client."
    }

    return (
        <Dialog open={open} fullWidth={true} maxWidth="md" onClose={onClose} isloading={loading}>
            <DialogTitle>
                {title}
            </DialogTitle>
            {loading ? (
                <div className="loaderContainer">
                    <CircularProgress />
                </div>
            ) : (
                <>
                    <DialogContent>
                        {mode !== "Create" && (
                            <Row>
                                <Col md={6}>
                                    <Field
                                        name={`${clientPrefix}active`}
                                        component={({ input }) => (
                                            <FormControlLabel
                                                className='mt-3'
                                                control={
                                                    <Switch
                                                        checked={!!input.value}
                                                        onChange={e => {
                                                            input.onChange(e);
                                                        }}
                                                        color="primary"
                                                    />
                                                }
                                                label={input.value ? 'Active' : 'Inactive'}
                                            />
                                        )}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col md={6}>
                                <InputField name={`${clientPrefix}name`}
                                    label="Name *"
                                    required
                                />
                            </Col>
                            <Col>
                                <DropdownField
                                    name={`${clientPrefix}businessType`}
                                    label="Business Type"
                                    options={businessTypeOption}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <InputField
                                    name={`${clientPrefix}address1`}
                                    label="Address *"
                                    required
                                />
                            </Col>
                            <Col>
                                <InputField
                                    name={`${clientPrefix}city`}
                                    label="City *"
                                    required
                                />
                            </Col>
                            <Col>
                                <DropdownField
                                    name={`${clientPrefix}state`}
                                    label="State"
                                    options={statesOptions.USA}
                                    required
                                />
                            </Col>
                            <Col>
                                <InputField name={`${clientPrefix}zip5`}
                                    label="Zipcode *"
                                    required
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <InputField
                                    name={`${clientPrefix}phone`}
                                    label="Phone *"
                                    validate={phoneNumberValidation}
                                    required
                                    isphoneNumber
                                />
                            </Col>
                            <Col md={6}>
                                <InputField
                                    name={`${clientPrefix}website`}
                                    label="Website"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <InputField
                                    name={`${clientPrefix}customFCSUsername`}
                                    label="FCS User Name"
                                />
                            </Col>
                            <Col md={6}>
                                <InputField
                                    name={`${clientPrefix}customFCSPassword`}
                                    label="FCS Password"
                                />
                            </Col>
                        </Row>
                            <Row>
                                <Col md={6}>
                                    <InputField
                                        name={`${clientPrefix}email`}
                                        label={isSwitchChecked ? strings.NOTIFICATION_FORM.NOTIFICATION_EMAIL_ASTERISK : strings.NOTIFICATION_FORM.NOTIFICATION_EMAIL}
                                        validate={isSwitchChecked ? [validateEmail, required] : [validateEmail]}
                                    />
                                </Col>
                                <Col md={6}>
                                    <Field
                                        name={`${clientPrefix}uccStatusNotificationEnabled`}
                                        component={({ input }) => (
                                            <FormControlLabel
                                                className='mt-3'
                                                control={
                                                    <Switch
                                                        checked={!!input.value}
                                                        onChange={e => {
                                                            input.onChange(e);
                                                            setIsSwitchChecked(e.target.checked);
                                                        }}
                                                        color="primary"
                                                    />
                                                }
                                                label={input.value ? strings.NOTIFICATION_FORM.UCC_NOTIFICATIONS_ENABLED : strings.NOTIFICATION_FORM.UCC_NOTIFICATIONS_DISABLED}
                                            />
                                        )}
                                    />
                                </Col>
                            </Row>
                        <Row>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}sprsByDefault`}
                                    label='Secured Party Masked'
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}clientReferenceRequired`}
                                    label='Client Reference Required'
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}clientReferenceUnique`}
                                    label='Client Reference Unique'
                                />
                            </Col>
                        </Row>
                        <Row>
                            <div className='heading-style-2 font-weight-bold mt-2 ml-3'>
                                {strings.HIDDEN} {strings.APPLICATION} {strings.COLUMNS}:
                            </div>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}hideFmcsa`}
                                    label='FMCSA'
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}hideDecisioning`}
                                    label='Decisioning'
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}hideVerification`}
                                    label='Verification'
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}hideCreditCheck`}
                                    label='Credit Check'
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}hideBankTransactions`}
                                    label='Bank Transactions'
                                />
                            </Col>
                        </Row>
                        <Row>
                            <div className='heading-style-2 font-weight-bold mt-2 ml-3'>
                                {strings.ADMIN.FEATURES_ENABLED}:
                            </div>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}sosSearchEnabled`}
                                    label='SOS Search'
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}newUccEnabled`}
                                    label='New UCC'
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}demoModeEnabled`}
                                    label='Demo Mode'
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}uccFilingRecordingTaxEnabled`}
                                    label={strings.NOTIFICATION_FORM.UCC_FILING_RECORDING_TAX_ENABLED}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}creditMemoEnabled`}
                                    label={'Credit Memo'}
                                />
                            </Col>
                             <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}debtorUnderwritingEnabled`}
                                    label={'Debtor Underwriting'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}customFCSCredentialsRequired`}
                                    label={'Custom FCS Credentials Required'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}termLexisReportsTos`}
                                    label={'Background (Lexis) Terms Accepted'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}termFcsReportsTos`}
                                    label={'UCC (FCS) Terms Accepted'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}monitoringEnabled`}
                                    label={'Monitoring Enabled'}
                                />
                            </Col>
                             <Col md={4}>
                                 <CheckboxField
                                     name={`${clientPrefix}trialAccount`}
                                     label={'Trial Account'}
                                 />
                            </Col>
                                <Col md={4}>
                                    <CheckboxField
                                        name={`${clientPrefix}docusingEnabled`}
                                        label={'DocuSign Enabled'}
                                    />
                                </Col>
                                <Col md={4}>
                                    <CheckboxField
                                        name={`${clientPrefix}gmailPdfImportEnabled`}
                                        label={'Gmail PDF Import Enabled'}
                                    />
                                </Col>
                                <Col md={4}>
                                    <CheckboxField
                                        name={`${clientPrefix}gmailPdfImportActive`}
                                        label={'Gmail PDF Import Active'}
                                    />
                                </Col>
                                <Col md={4}>
                                    <CheckboxField
                                        name={`${clientPrefix}activityDashboardEnabled`}
                                        label={'Activity Dashboard Enabled'}
                                    />
                                </Col>
                                <Col md={4}>
                                    <CheckboxField
                                        name={`${clientPrefix}taskAssignmentEmails`}
                                        label={'Email Task Notifications'}
                                    />
                                </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}externalApplicationCreationEnabled`}
                                    label={'External Application Creation Enabled'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}arBalanceEnabled`}
                                    label={'AR Balance Enabled'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}hubSpotIntegrationEnabled`}
                                    label={'HubSpot Integration Enabled'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}brokerPortalEnabled`}
                                    label={'Broker Portal Enabled'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}sosAllStatesSearchEnabled`}
                                    label={'Sos All States Search Enabled'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}marketplaceEnabled`}
                                    label={'Market Place Enabled'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}fmcsaExtensiveSearchEnabled`}
                                    label={'FMCSA Extensive Search Enabled'}
                                />
                            </Col>
                        </Row>

                        {creditMemoApprovalEnabled && (
                            <>
                                <Row>
                                    <div className='heading-style-2 font-weight-bold mt-4 ml-3'>
                                        {strings.ADMIN.CREDIT_MEMO_APPROVAL}:
                                    </div>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <CheckboxField
                                            name={`${clientPrefix}creditMemoRejectionEmails`}
                                            label={strings.ADMIN.CREDIT_MEMO_REJECTION_EMAILS}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )}

                        <Row>
                            <div className='heading-style-2 font-weight-bold mt-4 ml-3'>
                                New Feature Flags:
                            </div>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}featureFlags.REPUTATIONAL_AI_AGENT`}
                                    label={'Reputational AI Agent'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}featureFlags.TIN_VERIFICATION`}
                                    label={'TIN Verification'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}featureFlags.MOTUS`}
                                    label={'Motus'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}featureFlags.SAMGOV`}
                                    label={'SAM.gov'}
                                />
                            </Col>
							<Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}featureFlags.BANK_DOC_ANALYSIS`}
                                    label={'Bank Document Analysis'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}featureFlags.NEW_APPLICATION_DETAIL`}
                                    label={'New Application Detail Layout'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}featureFlags.TWO_FACTOR_REQUIRED`}
                                    label={'Two-Factor Authentication Required'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}featureFlags.BALANCE_SHEET_ANALYSIS`}
                                    label={'Balance Sheet Analysis'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}featureFlags.INCOME_STATEMENT_ANALYSIS`}
                                    label={'Income Statement Analysis'}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}featureFlags.CASH_FLOW_STATEMENT_ANALYSIS`}
                                    label={'Cash Flow Statement Analysis'}
                                />
                            </Col>
                            <Col md={4}>
                                <CheckboxField
                                    name={`${clientPrefix}featureFlags.DSCR_ANALYSIS`}
                                    label={'DSCR Analysis'}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <div className='heading-style-2 font-weight-bold mt-4 ml-3'>
                                {strings.ADMIN.FACTORCLOUD_INTEGRATION}:
                            </div>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <InputField
                                name={`${clientPrefix}factorCloudFactorSubdomain`}
                                label="Factor Sub Domain"
                            />
                            </Col>
                            <Col md={4}>
                                <InputField
                                name={`${clientPrefix}factorCloudFactorId`}
                                label="Factor ID"
                            />
                            </Col>
                            <Col md={4}>
                                <InputField
                                name={`${clientPrefix}factorCloudUsername`}
                                label="FactorCloud Username"
                            />
                            </Col>
                            <Col md={4}>
                                <InputField
                                name={`${clientPrefix}factorCloudPassword`}
                                label="FactorCloud Password"
                            />
                            </Col>
                        </Row>
                        <Row>
                            <div className='heading-style-2 font-weight-bold mt-4 ml-3'>
                                {strings.ADMIN.TRIAL_SETTINGS}:
                            </div>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <InputField
                                    name={`${clientPrefix}trialApplications`}
                                    label="Limit of Applications"
                                    type={"number"}
                                />
                            </Col>
                        </Row>
                            <Row>
                                <div className='heading-style-2 font-weight-bold mt-4 ml-3'>
                                    {strings.ADMIN.GMAIL_INTEGRATION}:
                                </div>
                            </Row>
                            <Row>
                                <Col >
                                    <Button
                                        name={`${clientPrefix}gmailConnect`}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => onGmailConnect()}
                                    >
                                        {strings.ADMIN.CONNECT_GMAIL}
                                    </Button>
                                </Col>
                            </Row>

                            <Row>
                                <div className='heading-style-2 font-weight-bold mt-4 ml-3'>
                                    {strings.ADMIN.BRIGHTBOLT_INTEGRATION}:
                                </div>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <InputField
                                        name={`${clientPrefix}brighboltClientId`}
                                        label="Brighbolt Client Id"
                                    />
                                </Col>
                                <Col>
                                    <InputField
                                        name={`${clientPrefix}brighboltApiKey`}
                                        label="Brighbolt Api Key"
                                        type="text"
                                    />
                                </Col>
                            </Row>


                    </DialogContent>

                    {mode === "Create" && isPlatformAdmin && (
                        <>
                            <DialogTitle>
                                {strings.USER} {strings.DETAILS}
                            </DialogTitle>

                            <DialogContent>
                                <Row>
                                    <Col md={3}>
                                        <InputField
                                            name="user.firstName"
                                            label="First Name *"
                                            required
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <InputField
                                            name="user.lastName"
                                            label="Last Name *"
                                            required
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <DropdownField
                                            name="roles[0]"
                                            label="Role"
                                            options={userRoles}
                                            getFullValue
                                            required
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <InputField
                                            name="user.phone"
                                            label="Phone *"
                                            validate={phoneNumberValidation}
                                            isphoneNumber
                                            required
                                        />
                                    </Col>
                                    <Col>
                                        <InputField
                                            name="user.email"
                                            label="Email *"
                                            validate={validateEmail}
                                            required
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <PasswordValidator password={password} isValid={setValid} open={openTooltip} >
                                            <InputField
                                                name="user.password"
                                                label="New Password *"
                                                type="password"
                                                validate={maxLength20}
                                                required
                                                onFocus={() => setOpenTooltip(true)}
                                                onBlur={() => setOpenTooltip(false)}
                                            />
                                        </PasswordValidator>
                                    </Col>
                                    <Col>
                                        <InputField
                                            name="user.confirmPassword"
                                            label="Confirm Password *"
                                            type="password"
                                            validate={passwordValidation}
                                            required
                                        />
                                    </Col>
                                </Row>
                            </DialogContent>
                        </>
                    )}
                </>
            )}

            <DialogActions>
                <Button color="primary" onClick={onClose}>
                    {strings.CANCEL}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={valid ? onSubmit : null}
                    disabled={loading || submitting || pristine || !valid}
                >
                    {mode} {strings.CUSTOMER}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ClientForm;
